// extracted by mini-css-extract-plugin
module.exports = {"content":"_25PmxgX6ELBfzsnFrfMin0","title":"_2ThAzFtxF61U4jELLTqM8U","date":"_3g08FSNmQVnPPXHD39soal","user":"_30b78wFzirvHmhvFqnWQSQ"};